import { gql } from 'apollo-boost'



export const FETCH_GLOBAL_SETTING = gql`
query damage_global_setting {
    damage_global_setting {
      step_2_instruction_video_url
      step_2_instruction_image_overview_url
      step_2_instruction_image_closeup_url
      id
      gdpr_content
      gdpr_bar_text
      color_parts_highlight
      step_2_instruction_image_closeup_text
      step_2_instruction_image_overview_text
      step_2_otherpart_image_url
    }
  }`;




